import { Dropdown } from '@johnlewispartnership/wtr-ingredients/dist/ingredients/Dropdown';
import { DropdownItem } from '@johnlewispartnership/wtr-ingredients/dist/ingredients/Dropdown/DropdownItem';
import { LabeledControl } from '@johnlewispartnership/wtr-ingredients/dist/ingredients/LabeledControl';
import { Radio } from '@johnlewispartnership/wtr-ingredients/dist/ingredients/Radio';

import locator from 'locator';
import { useSearchParams } from 'renderer/hooks/useSearchParams';

import {
  RECIPE_LAST_PUBLISHED,
  RECIPE_QUERY_PAGE,
  RECIPE_QUERY_SORT_BY,
  RECIPE_QUERY_START_PAGE,
  RECIPE_SEARCH_PATH,
  RECIPE_SORT_OPTIONS,
  RECIPE_SEARCH_SORT_OPTIONS,
} from '../constants';

const RecipeSortBy = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const pathname = locator.pathname;

  const sortOptions =
    pathname === RECIPE_SEARCH_PATH ? RECIPE_SEARCH_SORT_OPTIONS : RECIPE_SORT_OPTIONS;
  const defaultSortOption = pathname === RECIPE_SEARCH_PATH ? '' : RECIPE_LAST_PUBLISHED;
  const currentSortValue = searchParams.get(RECIPE_QUERY_SORT_BY) ?? defaultSortOption;
  const selectedSortOption = sortOptions.find(({ value }) => value === currentSortValue);

  const handleSortOptionChange = (_e: React.SyntheticEvent, menuItem: HTMLElement) => {
    setSearchParams({
      [RECIPE_QUERY_SORT_BY]: `${menuItem.dataset.itemValue}`,
      [RECIPE_QUERY_PAGE]: null,
      [RECIPE_QUERY_START_PAGE]: null,
    });
  };

  return (
    <Dropdown
      label={`Sort by: ${selectedSortOption?.label}`}
      direction="bottom-end"
      handleItemSelect={handleSortOptionChange}
      closeOnClick
    >
      {sortOptions.map(({ label, value }) => {
        const checked = value === selectedSortOption?.value;

        return (
          <DropdownItem
            key={value}
            component={LabeledControl}
            data-item-value={value}
            control={<Radio readOnly tabIndex={-1} name={label} checked={checked} />}
            label={label}
            role="radio"
            aria-checked={checked}
          />
        );
      })}
    </Dropdown>
  );
};

export default RecipeSortBy;
